// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root[data-theme="dark"] {
  /* Backgrounds */
  --bg-primary: #121212;       /* deepest charcoal */
  --bg-secondary: #181818;
  --bg-tertiary: #1f1f1f;
  --bg-quaternary: #242424;

  /* Borders */
  --border-primary: #2e2e2e;
  --border-secondary: #3a3a3a;

  /* Text */
  --text-primary: #ececec;     /* off-white */
  --text-secondary: #c9c9c9;   /* light gray */
  --text-muted: #9a9a9a;       /* muted gray */

  /* Buttons (lighter bluish-gray tones) */
  --btn-primary: #2f3b4d;      /* medium bluish-gray */
  --btn-secondary: #374355;    /* slightly deeper slate */
  --btn-tertiary: #414d60;     /* darker variant for contrast */

  /* Button text */
  --btn-text: #f5f5f5;         /* bright but soft white */
  --btn-text-muted: #c4c4c4;

  /* Chat bubbles */
  --user-bg: #2f3b4d;          /* same as primary button */
  --assistant-bg: #1e1e1e;     /* neutral charcoal */

  /* Shadows (soft depth) */
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.18);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.22),
               0 2px 4px -2px rgb(0 0 0 / 0.22);
  --shadow-lg: 0 8px 12px -3px rgb(0 0 0 / 0.28),
               0 4px 6px -4px rgb(0 0 0 / 0.28);
}



:root[data-theme="light"] {
  --bg-primary: #ffffff;
  --bg-secondary: #f8f9fa;
  --bg-tertiary: #f1f3f4;
  --bg-quaternary: #e8eaed;
  --border-primary: #dadce0;
  --border-secondary: #c4c7c5;
  --text-primary: #202124;
  --text-secondary: #5f6368;
  --text-muted: #9aa0a6;
  --accent-primary: #1a73e8;
  --accent-secondary: #1557b0;
  --accent-success: #137333;
  --accent-warning: #ea8600;
  --accent-danger: #d93025;
  --user-bg: #1a73e8;
  --assistant-bg: #9a9a9a;
  --shadow-sm: 0 1px 2px 0 rgb(60 64 67 / 0.3);
  --shadow-md: 0 1px 3px 0 rgb(60 64 67 / 0.15), 0 4px 8px 3px rgb(60 64 67 / 0.15);
  --shadow-lg: 0 2px 6px 2px rgb(60 64 67 / 0.15), 0 8px 24px 4px rgb(60 64 67 / 0.15);
  --shadow-xl: 0 4px 16px 6px rgb(60 64 67 / 0.15), 0 8px 32px 8px rgb(60 64 67 / 0.15);
}

* {
  box-sizing: border-box;
}

html,
body,
#root {
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  line-height: 1.6;
  overflow: hidden;
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Theme Context Classes */
.text-foreground { color: var(--text-primary); }
.text-muted-foreground { color: var(--text-muted); }
.bg-background { background: var(--bg-primary); }
.bg-card { background: var(--bg-secondary); }
.bg-muted { background: var(--bg-tertiary); }
.text-primary { color: var(--accent-primary); }
.text-destructive { color: var(--accent-danger); }
.border-destructive { border-color: var(--accent-danger); }

/* Advanced Modal Styles */
.space-y-6 > * + * { margin-top: 1.5rem; }
.space-y-4 > * + * { margin-top: 1rem; }
.space-y-2 > * + * { margin-top: 0.5rem; }
.gap-3 { gap: 0.75rem; }
.gap-2 { gap: 0.5rem; }
.gap-4 { gap: 1rem; }
.gap-6 { gap: 1.5rem; }
.gap-8 { gap: 2rem; }
.flex { display: flex; }
.flex-col { flex-direction: column; }
.flex-wrap { flex-wrap: wrap; }
.items-center { align-items: center; }
.items-start { align-items: flex-start; }
.justify-center { justify-content: center; }
.justify-between { justify-content: space-between; }
.justify-end { justify-content: flex-end; }
.grid { display: grid; }
.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.md\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

.label {
  display: block;
  font-size: 11px;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 0.25rem;
}

.input, .select, .textarea {
  width: 100%;
  padding: 6px 8px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-tertiary);
  color: var(--text-primary);
  font-size: 11px;
  transition: all 0.2s ease;
  font-family: inherit;
}

.textarea {
  resize: vertical;
  min-height: 60px;
}

.input:focus, .select:focus, .textarea:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);
}

[data-theme="dark"] .input:focus,
[data-theme="dark"] .select:focus,
[data-theme="dark"] .textarea:focus {
  box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.2);
}

.checkbox {
  width: 14px;
  height: 14px;
  accent-color: var(--accent-primary);
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 6px 12px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 11px;
  transition: all 0.2s ease;
  font-family: inherit;
  background: var(--accent-primary);
  color: white;
  box-shadow: var(--shadow-sm);
}

.btn:hover:not(:disabled) {
  background: var(--accent-secondary);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.btn-outline {
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-primary);
}

.btn-outline:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border-color: var(--border-secondary);
}

.btn-ghost {
  background: transparent;
  color: var(--text-secondary);
  border: none;
  box-shadow: none;
}

.btn-ghost:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.btn-secondary {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
}

.btn-sm {
  padding: 4px 8px;
  font-size: 10px;
}

.card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 6px;
  box-shadow: var(--shadow-sm);
}

.card-header {
  padding: 12px;
  border-bottom: 1px solid var(--border-primary);
}

.card-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.card-description {
  color: var(--text-muted);
  font-size: 10px;
  margin-top: 2px;
}

.card-content {
  padding: 12px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.switch-on {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
}

.switch-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
}

.switch-on .switch-thumb {
  transform: translateX(16px);
}

.separator {
  border: none;
  border-top: 1px solid var(--border-primary);
  margin: 0.75rem 0;
}

.border {
  border: 1px solid var(--border-primary);
}

.rounded, .rounded-lg {
  border-radius: 4px;
}

.p-2 { padding: 0.5rem; }
.p-4 { padding: 1rem; }
.py-4 { padding-top: 1rem; padding-bottom: 1rem; }

.text-sm { font-size: 10px; }
.text-lg { font-size: 14px; }
.text-2xl { font-size: 18px; }
.text-3xl { font-size: 22px; }

.font-bold { font-weight: 700; }
.font-semibold { font-weight: 600; }

.mr-2 { margin-right: 0.5rem; }
.ml-1 { margin-left: 0.25rem; }
.mb-4 { margin-bottom: 1rem; }
.mt-2 { margin-top: 0.5rem; }
.mt-6 { margin-top: 1.5rem; }

.w-full { width: 100%; }

.badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 500;
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
}

.badge-outline {
  background: transparent;
  border: 1px solid var(--border-primary);
}

.badge-secondary {
  background: var(--accent-primary);
  color: white;
  border: 1px solid var(--accent-primary);
}

.alert {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 8px;
  background: rgba(255, 153, 0, 0.1);
  border: 1px solid var(--accent-warning);
  border-radius: 4px;
  color: var(--text-primary);
}

.alert-description {
  font-size: 10px;
  margin: 0;
}

.tabs-list {
  display: flex;
  background: var(--bg-tertiary);
  border-radius: 6px;
  padding: 4px;
  gap: 2px;
}

.tabs-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  flex: 1 1;
}

.tabs-trigger:hover {
  color: var(--text-primary);
  background: var(--bg-quaternary);
}

.tabs-trigger.active {
  background: var(--bg-primary);
  color: var(--text-primary);
  box-shadow: var(--shadow-sm);
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.dialog-content {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  box-shadow: var(--shadow-xl);
  width: 95vw;
  max-width: 600px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: modalFadeIn 0.2s ease-out;
}

.dialog-content-large {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  box-shadow: var(--shadow-xl);
  width: 95vw;
  max-width: 1200px;
  height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: modalFadeIn 0.2s ease-out;
  padding: 16px;
}

.dialog-header {
  margin-bottom: 0.75rem;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-primary);
}

.dialog-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.dialog-description {
  color: var(--text-muted);
  font-size: 11px;
  margin-top: 4px;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 0.75rem;
  padding-top: 12px;
  border-top: 1px solid var(--border-primary);
}

.scrollbar-thin {
  scrollbar-width: thin;
  scrollbar-color: var(--border-primary) transparent;
  overflow-y: auto;
}

.scrollbar-thin::-webkit-scrollbar {
  width: 4px;
}

.scrollbar-thin::-webkit-scrollbar-track {
  background: transparent;
}

.scrollbar-thin::-webkit-scrollbar-thumb {
  background: var(--border-primary);
  border-radius: 2px;
}

.scrollbar-thin::-webkit-scrollbar-thumb:hover {
  background: var(--border-secondary);
}

.min-h-screen {
  min-height: 100vh;
}

.px-8 { padding-left: 2rem; padding-right: 2rem; }
.py-4 { padding-top: 1rem; padding-bottom: 1rem; }

.chat-shell {
  height: 100vh;
  display: flex;
  background: var(--bg-primary);
}

/* Sidebar Styles */
.sidebar {
  display: flex;
  background: var(--bg-secondary);
  border-right: 1px solid var(--border-primary);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 100;
  flex-shrink: 0;
}

.sidebar:not(.open) {
  width: 40px;
}

.sidebar.open {
  width: 280px;
}

.history-sidebar {
  z-index: 103;
}

.upload-sidebar {
  z-index: 102;
}

.config-sidebar {
  z-index: 101;
}

.sidebar-toggle {
  width: 40px;
  height: 100vh;
  background: var(--bg-tertiary);
  border-right: 1px solid var(--border-primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  z-index: 101;
  flex-shrink: 0;
}

.sidebar-toggle:hover {
  background: var(--bg-quaternary);
}

.sidebar-toggle-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 11px;
  font-weight: 500;
  color: var(--text-muted);
  letter-spacing: 0.1em;
  margin: 8px 0;
  text-transform: uppercase;
}

.sidebar-toggle i {
  color: var(--text-muted);
  font-size: 12px;
  margin-top: 8px;
}

.sidebar-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: var(--bg-secondary);
  overflow: hidden;
  width: 240px;
}

.sidebar-header {
  padding: 16px;
  border-bottom: 1px solid var(--border-primary);
  background: var(--bg-tertiary);
  flex-shrink: 0;
}

.sidebar-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  color: var(--text-primary);
}

.sidebar-title i {
  color: var(--accent-primary);
  font-size: 14px;
}

.sidebar-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 0;
}

.sidebar-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;
}

.section-heading {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}

.section-heading i {
  font-size: 12px;
  color: var(--accent-primary);
}

/* Vector Database Toggle */
.vector-db-toggle {
  margin-bottom: 12px;
}

.vector-db-toggle .toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  cursor: pointer;
}

.vector-db-toggle .toggle-info {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vector-db-toggle .toggle-label {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--text-primary);
  font-weight: 500;
  font-size: 12px;
}

.vector-db-toggle .toggle-label i {
  color: var(--accent-primary);
  font-size: 11px;
}

.vector-db-toggle .toggle-switch {
  position: relative;
  width: 36px;
  height: 20px;
  margin: 0 12px;
}

/* RAG Type Toggle */
.rag-type-toggle {
  margin-bottom: 12px;
}

.rag-type-toggle .toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  cursor: pointer;
}

.rag-type-toggle .toggle-info {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rag-type-toggle .toggle-label {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--text-primary);
  font-weight: 500;
  font-size: 12px;
}

.rag-type-toggle .toggle-label i {
  color: var(--accent-primary);
  font-size: 11px;
}

.rag-type-toggle .toggle-switch {
  position: relative;
  width: 36px;
  height: 20px;
  margin: 0 12px;
}

.workflow-selection,
.rag-index-selection,
.agentic-agent-selection {
  margin-bottom: 12px;
}

/* Search Mode Section */
.search-mode-section {
  margin-top: 12px;
}

.algo-description {
  margin-top: 8px;
}

.algo-desc {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 8px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  font-size: 11px;
  color: var(--text-muted);
  line-height: 1.4;
}

.algo-desc i {
  color: var(--accent-primary);
  margin-top: 1px;
  flex-shrink: 0;
}

/* Form Elements */
.select,
.input,
.system-input {
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid var(--border-primary);
  background: var(--bg-tertiary);
  color: var(--text-primary);
  font-size: 13px;
  transition: all 0.2s ease;
  font-family: inherit;
}

.select:focus,
.input:focus,
.system-input:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);
}

[data-theme="dark"] .select:focus,
[data-theme="dark"] .input:focus,
[data-theme="dark"] .system-input:focus {
  box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.2);
}

.select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.system-input {
  resize: vertical;
  min-height: 80px;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12px;
  line-height: 1.4;
}

/* Buttons */
.ghost,
.primary,
.danger {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 13px;
  transition: all 0.2s ease;
  font-family: inherit;
}

.ghost {
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-primary);
}

.ghost:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border-color: var(--border-secondary);
}

.primary {
  background: var(--accent-primary);
  color: white;
  box-shadow: var(--shadow-sm);
}

.primary:hover:not(:disabled) {
  background: var(--accent-secondary);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.danger {
  background: var(--accent-danger);
  color: white;
  box-shadow: var(--shadow-sm);
}

.danger:hover {
  background: #cc0000;
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

[data-theme="light"] .danger:hover {
  background: #b52d20;
}

.new-chat-btn {
  font-size: 13px;
  padding: 10px 16px;
  border-radius: 6px;
}

/* Theme Toggle */
.theme-toggle {
  margin-right: 12px;
}

.theme-toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid var(--border-primary);
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
}

.theme-toggle-btn:hover {
  background: var(--bg-quaternary);
  color: var(--text-primary);
  border-color: var(--border-secondary);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

/* Index Management */
.index-row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 8px;
  align-items: center;
}

.index-create {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
}

/* File Upload */
.dropzone {
  border: 2px dashed var(--border-primary);
  border-radius: 6px;
  padding: 16px;
  text-align: center;
  background: var(--bg-tertiary);
  transition: all 0.2s ease;
  cursor: pointer;
}

.dropzone:hover {
  border-color: var(--accent-primary);
  background: var(--bg-quaternary);
}

.dz-icon {
  font-size: 24px;
  color: var(--accent-primary);
  margin-bottom: 8px;
}

.dz-title {
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 4px;
  font-size: 13px;
}

.dz-sub {
  color: var(--text-muted);
  font-size: 11px;
  margin-bottom: 12px;
}

.files-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 100px;
  overflow-y: auto;
}

.file-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  font-size: 12px;
  color: var(--text-secondary);
}

.file-chip i {
  color: var(--accent-primary);
}

.file-chip span {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-remove-btn {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  padding: 2px;
  border-radius: 3px;
  transition: all 0.2s ease;
  font-size: 10px;
}

.file-remove-btn:hover {
  color: var(--accent-danger);
  background: rgba(217, 48, 37, 0.1);
}

[data-theme="dark"] .file-remove-btn:hover {
  background: rgba(255, 51, 51, 0.1);
}

.upload-msg {
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 11px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  color: var(--text-secondary);
}

/* Sessions */
.sessions-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 300px;
  overflow-y: auto;
}

.session-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  position: relative;
}

.session-item:hover {
  background: var(--bg-quaternary);
  transform: translateY(-1px);
}

.session-item:hover .session-actions {
  opacity: 1;
}

.session-item.active {
  background: rgba(26, 115, 232, 0.1);
  border-color: var(--accent-primary);
}

[data-theme="dark"] .session-item.active {
  background: rgba(0, 102, 255, 0.1);
}

.session-icon {
  width: 24px;
  height: 24px;
  background: var(--accent-primary);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 11px;
  flex-shrink: 0;
}

.session-info {
  flex: 1 1;
  min-width: 0;
}

.session-title {
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
  font-size: 13px;
}

.session-time {
  font-size: 10px;
  color: var(--text-muted);
}

.session-edit-input {
  width: 100%;
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 13px;
  font-family: inherit;
  margin-bottom: 4px;
  background: var(--bg-primary);
  color: var(--text-primary);
}

.session-edit-input:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 1px rgba(26, 115, 232, 0.15);
}

.session-actions {
  opacity: 0;
  transition: opacity 0.2s ease;
  display: flex;
  gap: 4px;
}

.session-action-btn {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  padding: 3px;
  border-radius: 3px;
  transition: all 0.2s ease;
  font-size: 10px;
}

.session-action-btn:hover {
  color: var(--accent-danger);
  background: rgba(217, 48, 37, 0.1);
}

[data-theme="dark"] .session-action-btn:hover {
  background: rgba(255, 51, 51, 0.1);
}

/* Toggle Switch */
.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  cursor: pointer;
}

.toggle-info {
  flex: 1 1;
}

.toggle-label {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--text-primary);
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 2px;
}

.toggle-label i {
  color: var(--accent-primary);
  font-size: 11px;
}

.toggle-desc {
  color: var(--text-muted);
  font-size: 11px;
}

.toggle-switch {
  position: relative;
  width: 36px;
  height: 20px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  transition: 0.3s;
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 2px;
  bottom: 2px;
  background-color: var(--text-muted);
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: var(--accent-primary);
  border-color: var(--accent-primary);
}

input:checked + .slider:before {
  transform: translateX(16px);
  background-color: white;
}

input:disabled + .slider {
  opacity: 0.5;
  cursor: not-allowed;
}

input:disabled + .slider:before {
  opacity: 0.5;
}

/* Radio Options */
.guardrails-options {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.radio-option {
  cursor: pointer;
}

.radio-option input {
  display: none;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  transition: all 0.2s ease;
}

.radio-option input:checked + .radio-label {
  background: rgba(26, 115, 232, 0.1);
  border-color: var(--accent-primary);
}

[data-theme="dark"] .radio-option input:checked + .radio-label {
  background: rgba(0, 102, 255, 0.1);
}

.radio-label i {
  color: var(--accent-primary);
  font-size: 13px;
  width: 16px;
  text-align: center;
}

.option-title {
  font-weight: 500;
  color: var(--text-primary);
  font-size: 12px;
}

.option-desc {
  color: var(--text-muted);
  font-size: 10px;
  margin-top: 1px;
}

/* Main Chat Area */
.chat-main {
  display: grid;
  grid-template-rows: auto 1fr auto;
  background: var(--bg-primary);
  overflow: hidden;
  flex: 1 1;
  min-width: 0;
}

.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-primary);
  background: var(--bg-secondary);
}

.header-left .title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 16px;
  color: var(--text-primary);
}

.header-right {
  display: flex;
  align-items: center;
}

.title i {
  color: var(--accent-primary);
}

.session-id,
.rag-indicator {
  font-size: 13px;
  color: var(--text-muted);
  font-weight: 400;
}

.rag-indicator i {
  color: var(--accent-success);
}

/* Chat Messages */
.chat-log {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.msg {
  display: grid;
  grid-template-columns: 32px 1fr;
  gap: 12px;
  align-items: flex-start;
}

.msg-avatar {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: white;
  box-shadow: var(--shadow-sm);
}

.msg.user .msg-avatar {
  background: var(--user-bg);
}

.msg.assistant .msg-avatar {
  background: var(--assistant-bg);
}

.msg-body {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: var(--shadow-sm);
}

.msg.user .msg-body {
  background: rgba(26, 115, 232, 0.1);
  border-color: rgba(26, 115, 232, 0.3);
}

[data-theme="dark"] .msg.user .msg-body {
  background: rgba(0, 102, 255, 0.1);
  border-color: rgba(0, 102, 255, 0.3);
}

.msg.assistant .msg-body {
  background: var(--bg-secondary);
  border-color: var(--border-primary);
}

.msg-role {
  font-size: 10px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 6px;
}

.agent-event-label {
  display: inline-block;
  margin-left: 8px;
  font-weight: 500;
  font-size: 10px;
  color: var(--text-muted);
  text-transform: none;
  letter-spacing: normal;
  opacity: 0.9;
}

.msg-content {
  color: var(--text-primary);
  line-height: 1.5;
  font-size: 14px;
}

/* Markdown Styles */
.markdown h1,
.markdown h2,
.markdown h3,
.markdown h4,
.markdown h5,
.markdown h6 {
  color: var(--text-primary);
  margin: 12px 0 6px 0;
}

.markdown p {
  margin: 6px 0;
}

.markdown ul,
.markdown ol {
  margin: 6px 0;
  padding-left: 16px;
}

.markdown li {
  margin: 3px 0;
}

.markdown code {
  background: var(--bg-tertiary);
  color: var(--accent-primary);
  padding: 2px 4px;
  border-radius: 3px;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12px;
}

.markdown pre {
  position: relative;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  border-radius: 6px;
  padding: 12px;
  margin: 8px 0;
  overflow-x: auto;
  box-shadow: var(--shadow-sm);
}

.markdown pre code {
  background: none;
  color: var(--text-primary);
  padding: 0;
  font-size: 12px;
  line-height: 1.4;
}

.copy-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: var(--bg-quaternary);
  border: 1px solid var(--border-primary);
  color: var(--text-secondary);
  border-radius: 3px;
  padding: 4px 6px;
  font-size: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.copy-btn:hover {
  background: var(--border-primary);
  color: var(--text-primary);
}

/* Empty State */
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  max-width: 500px;
  margin: 0 auto;
}

.empty-icon {
  font-size: 48px;
  color: var(--accent-primary);
  margin-bottom: 16px;
  opacity: 0.8;
}

.empty-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 6px;
}

.empty-subtitle {
  font-size: 14px;
  color: var(--text-muted);
  margin-bottom: 24px;
}

.empty-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 8px;
  width: 100%;
  margin-bottom: 16px;
}

.chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 6px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  font-size: 12px;
}

.chip:hover {
  background: var(--bg-tertiary);
  border-color: var(--accent-primary);
  color: var(--text-primary);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.chip i {
  color: var(--accent-primary);
  font-size: 10px;
}

.empty-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--text-muted);
  font-size: 11px;
}

.empty-hint i {
  color: var(--accent-primary);
}

/* Chat Input */
.chat-inputbar {
  padding: 16px 20px;
  border-top: 1px solid var(--border-primary);
  background: var(--bg-secondary);
}

.input-container {
  position: relative;
  display: flex;
  align-items: flex-end;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  padding: 3px;
  transition: all 0.2s ease;
}

.input-container:focus-within {
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);
}

[data-theme="dark"] .input-container:focus-within {
  box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.2);
}

.chat-input {
  flex: 1 1;
  background: transparent;
  border: none;
  color: var(--text-primary);
  font-size: 14px;
  line-height: 1.4;
  padding: 10px 12px;
  resize: none;
  max-height: 100px;
  min-height: 40px;
  font-family: inherit;
}

.chat-input:focus {
  outline: none;
}

.chat-input::placeholder {
  color: var(--text-muted);
}

.send-btn {
  background: var(--accent-primary);
  border: none;
  border-radius: 6px;
  padding: 8px;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin: 2px;
}

.send-btn:hover:not(:disabled) {
  background: var(--accent-secondary);
  transform: scale(1.05);
}

.send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}`, "",{"version":3,"sources":["webpack://./src/globals-wave.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qBAAqB,QAAQ,qBAAqB;EAClD,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;;EAExB,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;;EAE3B,SAAS;EACT,uBAAuB,MAAM,cAAc;EAC3C,yBAAyB,IAAI,eAAe;EAC5C,qBAAqB,QAAQ,eAAe;;EAE5C,wCAAwC;EACxC,sBAAsB,OAAO,uBAAuB;EACpD,wBAAwB,KAAK,0BAA0B;EACvD,uBAAuB,MAAM,gCAAgC;;EAE7D,gBAAgB;EAChB,mBAAmB,UAAU,0BAA0B;EACvD,yBAAyB;;EAEzB,iBAAiB;EACjB,kBAAkB,WAAW,2BAA2B;EACxD,uBAAuB,MAAM,qBAAqB;;EAElD,yBAAyB;EACzB,0CAA0C;EAC1C;+CAC6C;EAC7C;+CAC6C;AAC/C;;;;AAIA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,4CAA4C;EAC5C,iFAAiF;EACjF,oFAAoF;EACpF,qFAAqF;AACvF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,iHAAiH;EACjH,gBAAgB;EAChB,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA,0BAA0B;AAC1B,mBAAmB,0BAA0B,EAAE;AAC/C,yBAAyB,wBAAwB,EAAE;AACnD,iBAAiB,6BAA6B,EAAE;AAChD,WAAW,+BAA+B,EAAE;AAC5C,YAAY,8BAA8B,EAAE;AAC5C,gBAAgB,4BAA4B,EAAE;AAC9C,oBAAoB,2BAA2B,EAAE;AACjD,sBAAsB,kCAAkC,EAAE;;AAE1D,0BAA0B;AAC1B,qBAAqB,kBAAkB,EAAE;AACzC,qBAAqB,gBAAgB,EAAE;AACvC,qBAAqB,kBAAkB,EAAE;AACzC,SAAS,YAAY,EAAE;AACvB,SAAS,WAAW,EAAE;AACtB,SAAS,SAAS,EAAE;AACpB,SAAS,WAAW,EAAE;AACtB,SAAS,SAAS,EAAE;AACpB,QAAQ,aAAa,EAAE;AACvB,YAAY,sBAAsB,EAAE;AACpC,aAAa,eAAe,EAAE;AAC9B,gBAAgB,mBAAmB,EAAE;AACrC,eAAe,uBAAuB,EAAE;AACxC,kBAAkB,uBAAuB,EAAE;AAC3C,mBAAmB,8BAA8B,EAAE;AACnD,eAAe,yBAAyB,EAAE;AAC1C,QAAQ,aAAa,EAAE;AACvB,eAAe,gDAAgD,EAAE;AACjE,mBAAmB,gDAAgD,EAAE;;AAErE;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,iCAAiC;EACjC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,OAAO,eAAe,EAAE;AACxB,OAAO,aAAa,EAAE;AACtB,QAAQ,iBAAiB,EAAE,oBAAoB,EAAE;;AAEjD,WAAW,eAAe,EAAE;AAC5B,WAAW,eAAe,EAAE;AAC5B,YAAY,eAAe,EAAE;AAC7B,YAAY,eAAe,EAAE;;AAE7B,aAAa,gBAAgB,EAAE;AAC/B,iBAAiB,gBAAgB,EAAE;;AAEnC,QAAQ,oBAAoB,EAAE;AAC9B,QAAQ,oBAAoB,EAAE;AAC9B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,kBAAkB,EAAE;;AAE5B,UAAU,WAAW,EAAE;;AAEvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,uCAAuC;EACvC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,SAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,QAAQ,kBAAkB,EAAE,mBAAmB,EAAE;AACjD,QAAQ,iBAAiB,EAAE,oBAAoB,EAAE;;AAEjD;EACE,aAAa;EACb,aAAa;EACb,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,+BAA+B;EAC/B,6CAA6C;EAC7C,iDAAiD;EACjD,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;;;EAGE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mGAAmG;EACnG,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,8BAA8B;EAC9B,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,uCAAuC;EACvC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,iCAAiC;EACjC,6BAA6B;EAC7B,gBAAgB;EAChB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;;;;;;EAME,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,mGAAmG;EACnG,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gCAAgC;EAChC,uCAAuC;EACvC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,uCAAuC;EACvC,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,uCAAuC;EACvC,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[":root[data-theme=\"dark\"] {\n  /* Backgrounds */\n  --bg-primary: #121212;       /* deepest charcoal */\n  --bg-secondary: #181818;\n  --bg-tertiary: #1f1f1f;\n  --bg-quaternary: #242424;\n\n  /* Borders */\n  --border-primary: #2e2e2e;\n  --border-secondary: #3a3a3a;\n\n  /* Text */\n  --text-primary: #ececec;     /* off-white */\n  --text-secondary: #c9c9c9;   /* light gray */\n  --text-muted: #9a9a9a;       /* muted gray */\n\n  /* Buttons (lighter bluish-gray tones) */\n  --btn-primary: #2f3b4d;      /* medium bluish-gray */\n  --btn-secondary: #374355;    /* slightly deeper slate */\n  --btn-tertiary: #414d60;     /* darker variant for contrast */\n\n  /* Button text */\n  --btn-text: #f5f5f5;         /* bright but soft white */\n  --btn-text-muted: #c4c4c4;\n\n  /* Chat bubbles */\n  --user-bg: #2f3b4d;          /* same as primary button */\n  --assistant-bg: #1e1e1e;     /* neutral charcoal */\n\n  /* Shadows (soft depth) */\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.18);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.22),\n               0 2px 4px -2px rgb(0 0 0 / 0.22);\n  --shadow-lg: 0 8px 12px -3px rgb(0 0 0 / 0.28),\n               0 4px 6px -4px rgb(0 0 0 / 0.28);\n}\n\n\n\n:root[data-theme=\"light\"] {\n  --bg-primary: #ffffff;\n  --bg-secondary: #f8f9fa;\n  --bg-tertiary: #f1f3f4;\n  --bg-quaternary: #e8eaed;\n  --border-primary: #dadce0;\n  --border-secondary: #c4c7c5;\n  --text-primary: #202124;\n  --text-secondary: #5f6368;\n  --text-muted: #9aa0a6;\n  --accent-primary: #1a73e8;\n  --accent-secondary: #1557b0;\n  --accent-success: #137333;\n  --accent-warning: #ea8600;\n  --accent-danger: #d93025;\n  --user-bg: #1a73e8;\n  --assistant-bg: #9a9a9a;\n  --shadow-sm: 0 1px 2px 0 rgb(60 64 67 / 0.3);\n  --shadow-md: 0 1px 3px 0 rgb(60 64 67 / 0.15), 0 4px 8px 3px rgb(60 64 67 / 0.15);\n  --shadow-lg: 0 2px 6px 2px rgb(60 64 67 / 0.15), 0 8px 24px 4px rgb(60 64 67 / 0.15);\n  --shadow-xl: 0 4px 16px 6px rgb(60 64 67 / 0.15), 0 8px 32px 8px rgb(60 64 67 / 0.15);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n  line-height: 1.6;\n  overflow: hidden;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Theme Context Classes */\n.text-foreground { color: var(--text-primary); }\n.text-muted-foreground { color: var(--text-muted); }\n.bg-background { background: var(--bg-primary); }\n.bg-card { background: var(--bg-secondary); }\n.bg-muted { background: var(--bg-tertiary); }\n.text-primary { color: var(--accent-primary); }\n.text-destructive { color: var(--accent-danger); }\n.border-destructive { border-color: var(--accent-danger); }\n\n/* Advanced Modal Styles */\n.space-y-6 > * + * { margin-top: 1.5rem; }\n.space-y-4 > * + * { margin-top: 1rem; }\n.space-y-2 > * + * { margin-top: 0.5rem; }\n.gap-3 { gap: 0.75rem; }\n.gap-2 { gap: 0.5rem; }\n.gap-4 { gap: 1rem; }\n.gap-6 { gap: 1.5rem; }\n.gap-8 { gap: 2rem; }\n.flex { display: flex; }\n.flex-col { flex-direction: column; }\n.flex-wrap { flex-wrap: wrap; }\n.items-center { align-items: center; }\n.items-start { align-items: flex-start; }\n.justify-center { justify-content: center; }\n.justify-between { justify-content: space-between; }\n.justify-end { justify-content: flex-end; }\n.grid { display: grid; }\n.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.md\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n\n.label {\n  display: block;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 0.25rem;\n}\n\n.input, .select, .textarea {\n  width: 100%;\n  padding: 6px 8px;\n  border-radius: 4px;\n  border: 1px solid var(--border-primary);\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  font-size: 11px;\n  transition: all 0.2s ease;\n  font-family: inherit;\n}\n\n.textarea {\n  resize: vertical;\n  min-height: 60px;\n}\n\n.input:focus, .select:focus, .textarea:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);\n}\n\n[data-theme=\"dark\"] .input:focus,\n[data-theme=\"dark\"] .select:focus,\n[data-theme=\"dark\"] .textarea:focus {\n  box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.2);\n}\n\n.checkbox {\n  width: 14px;\n  height: 14px;\n  accent-color: var(--accent-primary);\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  padding: 6px 12px;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 11px;\n  transition: all 0.2s ease;\n  font-family: inherit;\n  background: var(--accent-primary);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.btn:hover:not(:disabled) {\n  background: var(--accent-secondary);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-outline {\n  background: transparent;\n  color: var(--text-secondary);\n  border: 1px solid var(--border-primary);\n}\n\n.btn-outline:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border-color: var(--border-secondary);\n}\n\n.btn-ghost {\n  background: transparent;\n  color: var(--text-secondary);\n  border: none;\n  box-shadow: none;\n}\n\n.btn-ghost:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.btn-secondary {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-primary);\n}\n\n.btn-sm {\n  padding: 4px 8px;\n  font-size: 10px;\n}\n\n.card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 6px;\n  box-shadow: var(--shadow-sm);\n}\n\n.card-header {\n  padding: 12px;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.card-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.card-description {\n  color: var(--text-muted);\n  font-size: 10px;\n  margin-top: 2px;\n}\n\n.card-content {\n  padding: 12px;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 36px;\n  height: 20px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-primary);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.switch-on {\n  background: var(--accent-primary);\n  border-color: var(--accent-primary);\n}\n\n.switch-thumb {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 14px;\n  height: 14px;\n  background: white;\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n}\n\n.switch-on .switch-thumb {\n  transform: translateX(16px);\n}\n\n.separator {\n  border: none;\n  border-top: 1px solid var(--border-primary);\n  margin: 0.75rem 0;\n}\n\n.border {\n  border: 1px solid var(--border-primary);\n}\n\n.rounded, .rounded-lg {\n  border-radius: 4px;\n}\n\n.p-2 { padding: 0.5rem; }\n.p-4 { padding: 1rem; }\n.py-4 { padding-top: 1rem; padding-bottom: 1rem; }\n\n.text-sm { font-size: 10px; }\n.text-lg { font-size: 14px; }\n.text-2xl { font-size: 18px; }\n.text-3xl { font-size: 22px; }\n\n.font-bold { font-weight: 700; }\n.font-semibold { font-weight: 600; }\n\n.mr-2 { margin-right: 0.5rem; }\n.ml-1 { margin-left: 0.25rem; }\n.mb-4 { margin-bottom: 1rem; }\n.mt-2 { margin-top: 0.5rem; }\n.mt-6 { margin-top: 1.5rem; }\n\n.w-full { width: 100%; }\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 500;\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-primary);\n}\n\n.badge-outline {\n  background: transparent;\n  border: 1px solid var(--border-primary);\n}\n\n.badge-secondary {\n  background: var(--accent-primary);\n  color: white;\n  border: 1px solid var(--accent-primary);\n}\n\n.alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 8px;\n  background: rgba(255, 153, 0, 0.1);\n  border: 1px solid var(--accent-warning);\n  border-radius: 4px;\n  color: var(--text-primary);\n}\n\n.alert-description {\n  font-size: 10px;\n  margin: 0;\n}\n\n.tabs-list {\n  display: flex;\n  background: var(--bg-tertiary);\n  border-radius: 6px;\n  padding: 4px;\n  gap: 2px;\n}\n\n.tabs-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: none;\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  flex: 1;\n}\n\n.tabs-trigger:hover {\n  color: var(--text-primary);\n  background: var(--bg-quaternary);\n}\n\n.tabs-trigger.active {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  box-shadow: var(--shadow-sm);\n}\n\n.dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.dialog-content {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 8px;\n  box-shadow: var(--shadow-xl);\n  width: 95vw;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: modalFadeIn 0.2s ease-out;\n}\n\n.dialog-content-large {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 8px;\n  box-shadow: var(--shadow-xl);\n  width: 95vw;\n  max-width: 1200px;\n  height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: modalFadeIn 0.2s ease-out;\n  padding: 16px;\n}\n\n.dialog-header {\n  margin-bottom: 0.75rem;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.dialog-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.dialog-description {\n  color: var(--text-muted);\n  font-size: 11px;\n  margin-top: 4px;\n}\n\n.dialog-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 0.75rem;\n  padding-top: 12px;\n  border-top: 1px solid var(--border-primary);\n}\n\n.scrollbar-thin {\n  scrollbar-width: thin;\n  scrollbar-color: var(--border-primary) transparent;\n  overflow-y: auto;\n}\n\n.scrollbar-thin::-webkit-scrollbar {\n  width: 4px;\n}\n\n.scrollbar-thin::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scrollbar-thin::-webkit-scrollbar-thumb {\n  background: var(--border-primary);\n  border-radius: 2px;\n}\n\n.scrollbar-thin::-webkit-scrollbar-thumb:hover {\n  background: var(--border-secondary);\n}\n\n.min-h-screen {\n  min-height: 100vh;\n}\n\n.px-8 { padding-left: 2rem; padding-right: 2rem; }\n.py-4 { padding-top: 1rem; padding-bottom: 1rem; }\n\n.chat-shell {\n  height: 100vh;\n  display: flex;\n  background: var(--bg-primary);\n}\n\n/* Sidebar Styles */\n.sidebar {\n  display: flex;\n  background: var(--bg-secondary);\n  border-right: 1px solid var(--border-primary);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  z-index: 100;\n  flex-shrink: 0;\n}\n\n.sidebar:not(.open) {\n  width: 40px;\n}\n\n.sidebar.open {\n  width: 280px;\n}\n\n.history-sidebar {\n  z-index: 103;\n}\n\n.upload-sidebar {\n  z-index: 102;\n}\n\n.config-sidebar {\n  z-index: 101;\n}\n\n.sidebar-toggle {\n  width: 40px;\n  height: 100vh;\n  background: var(--bg-tertiary);\n  border-right: 1px solid var(--border-primary);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  z-index: 101;\n  flex-shrink: 0;\n}\n\n.sidebar-toggle:hover {\n  background: var(--bg-quaternary);\n}\n\n.sidebar-toggle-text {\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text-muted);\n  letter-spacing: 0.1em;\n  margin: 8px 0;\n  text-transform: uppercase;\n}\n\n.sidebar-toggle i {\n  color: var(--text-muted);\n  font-size: 12px;\n  margin-top: 8px;\n}\n\n.sidebar-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-secondary);\n  overflow: hidden;\n  width: 240px;\n}\n\n.sidebar-header {\n  padding: 16px;\n  border-bottom: 1px solid var(--border-primary);\n  background: var(--bg-tertiary);\n  flex-shrink: 0;\n}\n\n.sidebar-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n.sidebar-title i {\n  color: var(--accent-primary);\n  font-size: 14px;\n}\n\n.sidebar-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-height: 0;\n}\n\n.sidebar-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.section-heading {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 8px;\n}\n\n.section-heading i {\n  font-size: 12px;\n  color: var(--accent-primary);\n}\n\n/* Vector Database Toggle */\n.vector-db-toggle {\n  margin-bottom: 12px;\n}\n\n.vector-db-toggle .toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  cursor: pointer;\n}\n\n.vector-db-toggle .toggle-info {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.vector-db-toggle .toggle-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--text-primary);\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.vector-db-toggle .toggle-label i {\n  color: var(--accent-primary);\n  font-size: 11px;\n}\n\n.vector-db-toggle .toggle-switch {\n  position: relative;\n  width: 36px;\n  height: 20px;\n  margin: 0 12px;\n}\n\n/* RAG Type Toggle */\n.rag-type-toggle {\n  margin-bottom: 12px;\n}\n\n.rag-type-toggle .toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  cursor: pointer;\n}\n\n.rag-type-toggle .toggle-info {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rag-type-toggle .toggle-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--text-primary);\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.rag-type-toggle .toggle-label i {\n  color: var(--accent-primary);\n  font-size: 11px;\n}\n\n.rag-type-toggle .toggle-switch {\n  position: relative;\n  width: 36px;\n  height: 20px;\n  margin: 0 12px;\n}\n\n.workflow-selection,\n.rag-index-selection,\n.agentic-agent-selection {\n  margin-bottom: 12px;\n}\n\n/* Search Mode Section */\n.search-mode-section {\n  margin-top: 12px;\n}\n\n.algo-description {\n  margin-top: 8px;\n}\n\n.algo-desc {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 8px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-primary);\n  border-radius: 4px;\n  font-size: 11px;\n  color: var(--text-muted);\n  line-height: 1.4;\n}\n\n.algo-desc i {\n  color: var(--accent-primary);\n  margin-top: 1px;\n  flex-shrink: 0;\n}\n\n/* Form Elements */\n.select,\n.input,\n.system-input {\n  width: 100%;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid var(--border-primary);\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  font-size: 13px;\n  transition: all 0.2s ease;\n  font-family: inherit;\n}\n\n.select:focus,\n.input:focus,\n.system-input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);\n}\n\n[data-theme=\"dark\"] .select:focus,\n[data-theme=\"dark\"] .input:focus,\n[data-theme=\"dark\"] .system-input:focus {\n  box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.2);\n}\n\n.select:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.system-input {\n  resize: vertical;\n  min-height: 80px;\n  font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas, \"Liberation Mono\", Menlo, monospace;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n/* Buttons */\n.ghost,\n.primary,\n.danger {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 13px;\n  transition: all 0.2s ease;\n  font-family: inherit;\n}\n\n.ghost {\n  background: transparent;\n  color: var(--text-secondary);\n  border: 1px solid var(--border-primary);\n}\n\n.ghost:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border-color: var(--border-secondary);\n}\n\n.primary {\n  background: var(--accent-primary);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.primary:hover:not(:disabled) {\n  background: var(--accent-secondary);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.danger {\n  background: var(--accent-danger);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.danger:hover {\n  background: #cc0000;\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n[data-theme=\"light\"] .danger:hover {\n  background: #b52d20;\n}\n\n.new-chat-btn {\n  font-size: 13px;\n  padding: 10px 16px;\n  border-radius: 6px;\n}\n\n/* Theme Toggle */\n.theme-toggle {\n  margin-right: 12px;\n}\n\n.theme-toggle-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: 1px solid var(--border-primary);\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n}\n\n.theme-toggle-btn:hover {\n  background: var(--bg-quaternary);\n  color: var(--text-primary);\n  border-color: var(--border-secondary);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Index Management */\n.index-row {\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  gap: 8px;\n  align-items: center;\n}\n\n.index-create {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 8px;\n}\n\n/* File Upload */\n.dropzone {\n  border: 2px dashed var(--border-primary);\n  border-radius: 6px;\n  padding: 16px;\n  text-align: center;\n  background: var(--bg-tertiary);\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.dropzone:hover {\n  border-color: var(--accent-primary);\n  background: var(--bg-quaternary);\n}\n\n.dz-icon {\n  font-size: 24px;\n  color: var(--accent-primary);\n  margin-bottom: 8px;\n}\n\n.dz-title {\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n  font-size: 13px;\n}\n\n.dz-sub {\n  color: var(--text-muted);\n  font-size: 11px;\n  margin-bottom: 12px;\n}\n\n.files-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 100px;\n  overflow-y: auto;\n}\n\n.file-chip {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 8px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-primary);\n  border-radius: 4px;\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.file-chip i {\n  color: var(--accent-primary);\n}\n\n.file-chip span {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.file-remove-btn {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 3px;\n  transition: all 0.2s ease;\n  font-size: 10px;\n}\n\n.file-remove-btn:hover {\n  color: var(--accent-danger);\n  background: rgba(217, 48, 37, 0.1);\n}\n\n[data-theme=\"dark\"] .file-remove-btn:hover {\n  background: rgba(255, 51, 51, 0.1);\n}\n\n.upload-msg {\n  padding: 6px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-primary);\n  color: var(--text-secondary);\n}\n\n/* Sessions */\n.sessions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.session-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-primary);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  position: relative;\n}\n\n.session-item:hover {\n  background: var(--bg-quaternary);\n  transform: translateY(-1px);\n}\n\n.session-item:hover .session-actions {\n  opacity: 1;\n}\n\n.session-item.active {\n  background: rgba(26, 115, 232, 0.1);\n  border-color: var(--accent-primary);\n}\n\n[data-theme=\"dark\"] .session-item.active {\n  background: rgba(0, 102, 255, 0.1);\n}\n\n.session-icon {\n  width: 24px;\n  height: 24px;\n  background: var(--accent-primary);\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 11px;\n  flex-shrink: 0;\n}\n\n.session-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.session-title {\n  font-weight: 500;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 2px;\n  font-size: 13px;\n}\n\n.session-time {\n  font-size: 10px;\n  color: var(--text-muted);\n}\n\n.session-edit-input {\n  width: 100%;\n  border: 1px solid var(--border-primary);\n  border-radius: 4px;\n  padding: 4px 6px;\n  font-size: 13px;\n  font-family: inherit;\n  margin-bottom: 4px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.session-edit-input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 1px rgba(26, 115, 232, 0.15);\n}\n\n.session-actions {\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  display: flex;\n  gap: 4px;\n}\n\n.session-action-btn {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 3px;\n  border-radius: 3px;\n  transition: all 0.2s ease;\n  font-size: 10px;\n}\n\n.session-action-btn:hover {\n  color: var(--accent-danger);\n  background: rgba(217, 48, 37, 0.1);\n}\n\n[data-theme=\"dark\"] .session-action-btn:hover {\n  background: rgba(255, 51, 51, 0.1);\n}\n\n/* Toggle Switch */\n.toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  cursor: pointer;\n}\n\n.toggle-info {\n  flex: 1;\n}\n\n.toggle-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--text-primary);\n  font-weight: 500;\n  font-size: 13px;\n  margin-bottom: 2px;\n}\n\n.toggle-label i {\n  color: var(--accent-primary);\n  font-size: 11px;\n}\n\n.toggle-desc {\n  color: var(--text-muted);\n  font-size: 11px;\n}\n\n.toggle-switch {\n  position: relative;\n  width: 36px;\n  height: 20px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--bg-tertiary);\n  border: 1px solid var(--border-primary);\n  transition: 0.3s;\n  border-radius: 20px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 14px;\n  width: 14px;\n  left: 2px;\n  bottom: 2px;\n  background-color: var(--text-muted);\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: var(--accent-primary);\n  border-color: var(--accent-primary);\n}\n\ninput:checked + .slider:before {\n  transform: translateX(16px);\n  background-color: white;\n}\n\ninput:disabled + .slider {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\ninput:disabled + .slider:before {\n  opacity: 0.5;\n}\n\n/* Radio Options */\n.guardrails-options {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.radio-option {\n  cursor: pointer;\n}\n\n.radio-option input {\n  display: none;\n}\n\n.radio-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-primary);\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.radio-option input:checked + .radio-label {\n  background: rgba(26, 115, 232, 0.1);\n  border-color: var(--accent-primary);\n}\n\n[data-theme=\"dark\"] .radio-option input:checked + .radio-label {\n  background: rgba(0, 102, 255, 0.1);\n}\n\n.radio-label i {\n  color: var(--accent-primary);\n  font-size: 13px;\n  width: 16px;\n  text-align: center;\n}\n\n.option-title {\n  font-weight: 500;\n  color: var(--text-primary);\n  font-size: 12px;\n}\n\n.option-desc {\n  color: var(--text-muted);\n  font-size: 10px;\n  margin-top: 1px;\n}\n\n/* Main Chat Area */\n.chat-main {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  background: var(--bg-primary);\n  overflow: hidden;\n  flex: 1;\n  min-width: 0;\n}\n\n.chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-primary);\n  background: var(--bg-secondary);\n}\n\n.header-left .title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  font-size: 16px;\n  color: var(--text-primary);\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n}\n\n.title i {\n  color: var(--accent-primary);\n}\n\n.session-id,\n.rag-indicator {\n  font-size: 13px;\n  color: var(--text-muted);\n  font-weight: 400;\n}\n\n.rag-indicator i {\n  color: var(--accent-success);\n}\n\n/* Chat Messages */\n.chat-log {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.msg {\n  display: grid;\n  grid-template-columns: 32px 1fr;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.msg-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.msg.user .msg-avatar {\n  background: var(--user-bg);\n}\n\n.msg.assistant .msg-avatar {\n  background: var(--assistant-bg);\n}\n\n.msg-body {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 8px;\n  padding: 12px 16px;\n  box-shadow: var(--shadow-sm);\n}\n\n.msg.user .msg-body {\n  background: rgba(26, 115, 232, 0.1);\n  border-color: rgba(26, 115, 232, 0.3);\n}\n\n[data-theme=\"dark\"] .msg.user .msg-body {\n  background: rgba(0, 102, 255, 0.1);\n  border-color: rgba(0, 102, 255, 0.3);\n}\n\n.msg.assistant .msg-body {\n  background: var(--bg-secondary);\n  border-color: var(--border-primary);\n}\n\n.msg-role {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 6px;\n}\n\n.agent-event-label {\n  display: inline-block;\n  margin-left: 8px;\n  font-weight: 500;\n  font-size: 10px;\n  color: var(--text-muted);\n  text-transform: none;\n  letter-spacing: normal;\n  opacity: 0.9;\n}\n\n.msg-content {\n  color: var(--text-primary);\n  line-height: 1.5;\n  font-size: 14px;\n}\n\n/* Markdown Styles */\n.markdown h1,\n.markdown h2,\n.markdown h3,\n.markdown h4,\n.markdown h5,\n.markdown h6 {\n  color: var(--text-primary);\n  margin: 12px 0 6px 0;\n}\n\n.markdown p {\n  margin: 6px 0;\n}\n\n.markdown ul,\n.markdown ol {\n  margin: 6px 0;\n  padding-left: 16px;\n}\n\n.markdown li {\n  margin: 3px 0;\n}\n\n.markdown code {\n  background: var(--bg-tertiary);\n  color: var(--accent-primary);\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas, \"Liberation Mono\", Menlo, monospace;\n  font-size: 12px;\n}\n\n.markdown pre {\n  position: relative;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-primary);\n  border-radius: 6px;\n  padding: 12px;\n  margin: 8px 0;\n  overflow-x: auto;\n  box-shadow: var(--shadow-sm);\n}\n\n.markdown pre code {\n  background: none;\n  color: var(--text-primary);\n  padding: 0;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.copy-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: var(--bg-quaternary);\n  border: 1px solid var(--border-primary);\n  color: var(--text-secondary);\n  border-radius: 3px;\n  padding: 4px 6px;\n  font-size: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.copy-btn:hover {\n  background: var(--border-primary);\n  color: var(--text-primary);\n}\n\n/* Empty State */\n.empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px 20px;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.empty-icon {\n  font-size: 48px;\n  color: var(--accent-primary);\n  margin-bottom: 16px;\n  opacity: 0.8;\n}\n\n.empty-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 6px;\n}\n\n.empty-subtitle {\n  font-size: 14px;\n  color: var(--text-muted);\n  margin-bottom: 24px;\n}\n\n.empty-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 8px;\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.chip {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 6px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  font-size: 12px;\n}\n\n.chip:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--accent-primary);\n  color: var(--text-primary);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.chip i {\n  color: var(--accent-primary);\n  font-size: 10px;\n}\n\n.empty-hint {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--text-muted);\n  font-size: 11px;\n}\n\n.empty-hint i {\n  color: var(--accent-primary);\n}\n\n/* Chat Input */\n.chat-inputbar {\n  padding: 16px 20px;\n  border-top: 1px solid var(--border-primary);\n  background: var(--bg-secondary);\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  align-items: flex-end;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-primary);\n  border-radius: 8px;\n  padding: 3px;\n  transition: all 0.2s ease;\n}\n\n.input-container:focus-within {\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);\n}\n\n[data-theme=\"dark\"] .input-container:focus-within {\n  box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.2);\n}\n\n.chat-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  color: var(--text-primary);\n  font-size: 14px;\n  line-height: 1.4;\n  padding: 10px 12px;\n  resize: none;\n  max-height: 100px;\n  min-height: 40px;\n  font-family: inherit;\n}\n\n.chat-input:focus {\n  outline: none;\n}\n\n.chat-input::placeholder {\n  color: var(--text-muted);\n}\n\n.send-btn {\n  background: var(--accent-primary);\n  border: none;\n  border-radius: 6px;\n  padding: 8px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  margin: 2px;\n}\n\n.send-btn:hover:not(:disabled) {\n  background: var(--accent-secondary);\n  transform: scale(1.05);\n}\n\n.send-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
